import { ValidateMessage } from "config/ValidateMessage";
import * as yup from "yup";
export const AuthSchema = {
  usuario: {
    type: "text",
    label: "Usuario",
  },
  password: {
    type: "password",
    label: "Contraseña",
  },
};

export const AuthValidation = yup.object().shape({
  usuario: yup
    .string()
    .required(ValidateMessage.REQUERIDO)
    .max(100, ValidateMessage.MAX.replace(":max", "100")),
  password: yup
    .string()
    .required(ValidateMessage.REQUERIDO)
    .max(100, ValidateMessage.MAX.replace(":max", "100")),
});
